
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

//System
import { Mappings } from './../../shared/mapping';

//Models
import { Configuration } from "./../../models/core/configuration";
import { HttpParam } from "./../../models/core/http-param";
import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';


@Injectable()
export class ConfigurationService {
  constructor(public _api: ApiService, public _cache: CacheService,
    private mappings: Mappings) {
  }

  getConfiguration(lang: string) {

    let url = this.mappings.Web_Api_Get_Configuration.replace('{lang}', lang);
    let key = url;

    return this._api.get(url);
  }

  //Return the routes for a given language
  getRoutes(lang: string) {

    let url = this.mappings.Web_Api_Get_Routes.replace('{lang}', lang);
    let key = url;

    return this._api.get(url);
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/configuration.service.ts